<template>
    <footer class="motor-footer" v-if="data">
        <div class="motor-container info-container">
            <article class="article article--info">
                <h3>Contact Info</h3>
                <p>{{data.contact.description}}</p>
                <ul>
                    <li class="address">
                        <a :href="data.contact.address_url">{{data.contact.address}}</a>
                    </li>
                    <li class="phone">
                        <a :href="'tel:' + data.contact.phone">{{data.contact.phone}}</a>
                    </li>
                    <li class="mail">
                        <a :href="'mailto:' + data.contact.email">{{data.contact.email}}</a>
                    </li>
                </ul>
            </article>
            <article class="article article--hours">
                <h3>Open Hours</h3>
                <div class="department" v-for="(data, i) in data.openhour" :key="i">
                    <h5>{{data.department}}</h5>
                    <p>
                        {{data.opening_time}} <br>
                        {{data.close_time}}
                    </p>
                </div>
            </article>
            <!-- <article class="article article--accept">
                <h3>We Accept</h3>
                <div class="we-accept">
                    <img v-for="(img, i) in data.weaccept" :key="i" :src="env.imageUrl + img.image" alt="master">
                </div>
            </article> -->
        </div>
        <section class="footer-bar">
            <div class="motor-container">
                <div class="section section--start">
                    &copy;Copyright 2019 MMC. All right reserved.
                </div>
                <div class="section section--center">
                    <a :href="data.social.facebook" target="_blank" class="social-link facebook"></a>
                    <a :href="data.social.youtube" target="_blank" class="social-link twitter"></a>
                </div>
                <div class="section section--end">
                    Made with love by <a href="https://venuslab.co/">Venus Lab</a>
                </div>
            </div>
        </section>
    </footer>
</template>

<script>
import {env} from '../enviorments'
export default {
    name: 'motor-footer',
    props: {
        data: Object,
    },
    data() {
        return {
            env,
        }
    }
}
</script>

<style lang="scss" scoped>
.motor-footer {
    padding: 30px 0;
    background-color: var(--third);
    color: #fff;
    .info-container {
        display: flex;
        flex-wrap: wrap;
        .article {
            padding: 10px;
            width: 100%;
            &.article--info {
                @media (min-width: 992px) {
                    flex: 2;
                }
                ul {
                    padding-left: 20px;
                    li {
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        &::before {
                            content: '';
                            display: block;
                            width: 18px;
                            height: 18px;
                            // background-color: #fff;
                            background-size: contain;
                            background-repeat: no-repeat;
                            background-position: center;
                            margin-right: 5px;
                        }
                        &.address::before {
                            background-image: url(../assets/icons/f1.svg);
                            background-size: 16px;
                        }
                        &.phone::before {
                            background-image: url(../assets/icons/f2.svg);
                            background-size: 14px;
                        }
                        &.mail::before {
                            background-image: url(../assets/icons/f3.svg);
                            background-size: 15px;
                        }
                        a {
                            text-decoration: none;
                            color: #fff;
                            font-weight: 300;
                            font-size: .9rem;
                            padding: 5px 0;
                        }
                    }
                }
            }
            &.article--hours {
                @media (min-width: 768px) {
                    flex: 1.7;
                    padding-left: 40px;
                }
                display: flex;
                flex-wrap: wrap;
                align-items: flex-start;
                justify-content: flex-start;
                h3 {
                    width: 100%;
                }
                .department {
                    width: 50%;
                    height: 100%;
                    align-self: flex-start;
                    h5 {
                        color: #fff;
                        padding-bottom: 0;
                        font-size: 1rem;
                        font-weight: 300;
                    }
                    p {
                        font-size: .9rem;
                    }
                }
            }
            &.article--accept {
                .we-accept {
                    img {
                        margin-right: 15px;
                    }
                }
                @media (min-width: 768px) {
                    flex: 1;
                }
            }
            h3 {
                color: #fff;
                font-weight: 300;
                @media (min-width: 992px) {
                    font-size: 1.5rem;
                }
            }
            p {
                color: #fff;
                max-width: 400px;
            }
        }
    }
    .footer-bar {
        padding: 20px 0;
        background-color: var(--footer-bg);
        @media (min-width: 768px) {
            padding: 30px 0;
        }
        .motor-container {
            display: flex;
            flex-wrap: wrap;
            .section {
                width: 100%;
                color: #fff;
                text-align: center;
                font-weight: 300;
                font-size: .8rem;
                @media (min-width: 768px) {
                    flex: 1;
                    &.section--start {
                        text-align: left;
                    }
                    &.section--end {
                        text-align: right;
                    }
                }
                a {
                    color: #fff;
                    line-height: 1rem;
                }
                &.section--center {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 10px 0;
                    @media (min-width: 768px) {
                        padding: 0;
                    }
                    .social-link {
                        display: block;
                        width: 15px;
                        height: 15px;
                        // background-color: #fff;
                        margin: 0 10px;
                        background-size: contain;
                        background-repeat: no-repeat;
                        background-position: center;
                        &.facebook {
                            background-image: url(../assets/icons/facebook.png);
                        }
                        &.twitter {
                            background-image: url(../assets/icons/youtube.svg);
                        }
                    }
                }
            }
        }
    }
}
</style>
